import { HiringRequest } from '@interfaces/open-positions.model';

export function mapResponse(hiringRequest: HiringRequest) {
  return {
    primarySkills: hiringRequest?.skillName?.toString(),
    hiringRequestId: hiringRequest.hiringRequestDto?.hiringRequestId ?? null,
    numberOfPositions: hiringRequest.hiringRequestDto?.numberOfPositions ?? 0,
    yearsOfExperience: hiringRequest.hiringRequestDto?.yearsOfExperience ?? 0,
    yearsOfRelevantExperience:
      hiringRequest.hiringRequestDto?.yearsOfRelevantExperience ?? 0,
    desiredStartDate: hiringRequest.hiringRequestDto?.desiredStartDate ?? '',
    additionalComments:
      hiringRequest.hiringRequestDto?.additionalComments ?? '',
    jobDescription: hiringRequest.hiringRequestDto?.jobDescription ?? '',
    jobDescriptionPath:
      hiringRequest.hiringRequestDto?.jobDescriptionPath ?? '',
    location: hiringRequest.hiringRequestDto?.location ?? '',
    isPriority: hiringRequest.hiringRequestDto?.isPriority ?? '',
    employeeId: hiringRequest.hiringRequestDto?.employeeId ?? null,
    status: hiringRequest.hiringRequestDto?.status ?? '',
    vendorName: Array.isArray(hiringRequest.hiringVendorDtoList)
      ? hiringRequest.hiringVendorDtoList?.map(
          (vendor: any) => vendor.vendorName,
        )
      : [],
    jobTitle: hiringRequest.hiringRequestDto?.jobTitle ?? '',
    lobName: hiringRequest.hiringRequestDto?.lobName ?? '',
    noOfCandidates: hiringRequest.hiringRequestDto?.noOfCandidates ?? 0,
    ageOld: hiringRequest.ageOld ?? 0,
    createdDate: hiringRequest.hiringRequestDto?.createdDate ?? '',
    dntLeaderName: hiringRequest.hiringRequestDto?.dntLeaderName ?? '',
    projectName: hiringRequest.hiringRequestDto?.projectName ?? '',
    hiringManagerName: hiringRequest.hiringRequestDto?.hiringManagerName ?? '',
    skillName: Array.isArray(hiringRequest.skillName)
      ? hiringRequest.skillName
      : typeof hiringRequest.skillName === 'string' && hiringRequest.skillName
        ? [hiringRequest.skillName]
        : Array.isArray(hiringRequest.hiringRequestDto?.skillName)
          ? hiringRequest.hiringRequestDto.skillName
          : typeof hiringRequest.hiringRequestDto?.skillName === 'string' &&
              hiringRequest.hiringRequestDto.skillName
            ? [hiringRequest.hiringRequestDto.skillName]
            : [],
  };
}
